<div class="mdm-rules">
  <div class="mdm-header">
    <h3>DCR Types</h3>
  </div>

  @if (isLoading) {
    <div class="mdm-loading"><span class="spinner"></span> Loading DCR types...</div>
  } @else {
    <div class="table-responsive app-table-wrap">
      <table class="table align-middle app-table">
        <thead>
          <tr>
            <th>DCR Type</th>
            <th>Description</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          @for (dcr of dcrTypes; track dcr.RequestType) {
            <tr>
              <td>{{ dcr.RequestType }}</td>
              <td>{{ dcr.RequestTypeDescription }}</td>
              <td>
                <span class="status-pill" [class.success]="isActiveStatus(dcr.RequestTypeStatus)" [class.danger]="!isActiveStatus(dcr.RequestTypeStatus)">
                  <i class="bi" [class.bi-check-circle-fill]="isActiveStatus(dcr.RequestTypeStatus)" [class.bi-x-circle-fill]="!isActiveStatus(dcr.RequestTypeStatus)"></i>
                  {{ dcr.RequestTypeStatus }}
                </span>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="3" class="text-center text-muted py-4">No DCR types available.</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
